import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Kids() {
  const [selectedCharacter, setSelectedCharacter] = useState<number | null>(null);
  const [currentQuiz, setCurrentQuiz] = useState(0);
  const [score, setScore] = useState(0);
  const [showQuizResult, setShowQuizResult] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null);
  const navigate = useNavigate();

  const biblicalCharacters = [
    {
      id: 1,
      name: 'Noé',
      story: 'Noé foi um homem muito obediente a Deus! Quando Deus disse para ele construir uma grande arca (um barco gigante), ele obedeceu. Deus queria salvar Noé, sua família e todos os animais de uma grande chuva que duraria 40 dias!',
      lesson: 'Devemos sempre obedecer a Deus, mesmo quando não entendemos tudo.',
      image: 'https://public.readdy.ai/ai/img_res/381c7ead933f1e7c682483ad9190c0c4.jpg',
      funFact: 'Noé tinha 600 anos quando entrou na arca! E ele levou 2 de cada animal!'
    },
    {
      id: 2,
      name: 'Davi',
      story: 'Davi era um menino pastor que cuidava das ovelhinhas. Ele era corajoso e confiava em Deus! Quando o gigante Golias desafiou o povo de Deus, Davi não teve medo. Com apenas uma pedra e uma funda, ele venceu o gigante!',
      lesson: 'Deus nos dá coragem para enfrentar nossos medos quando confiamos Nele.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20young%20David%20with%20sling%2C%20friendly%20sheep%2C%20colorful%20pastoral%20scene%2C%20children%20illustration%20style%2C%20brave%20little%20shepherd%20boy%2C%20biblical%20character%20for%20kids&width=400&height=300&seq=david-kids&orientation=landscape',
      funFact: 'Davi escreveu muitos salmos (músicas) para Deus! Ele tocava harpa também!'
    },
    {
      id: 3,
      name: 'Daniel',
      story: 'Daniel amava muito a Deus e orava todos os dias! Mesmo quando o rei proibiu as pessoas de orarem, Daniel continuou orando. Por isso, foi jogado na cova dos leões, mas Deus enviou um anjo para fechar a boca dos leões!',
      lesson: 'Devemos sempre orar e confiar em Deus, Ele nos protege.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Daniel%20with%20friendly%20lions%2C%20angel%20protecting%2C%20colorful%20cave%20scene%2C%20children%20illustration%20style%2C%20peaceful%20biblical%20story%20for%20kids&width=400&height=300&seq=daniel-kids&orientation=landscape',
      funFact: 'Daniel orava 3 vezes por dia olhando para Jerusalém!'
    },
    {
      id: 4,
      name: 'Moisés',
      story: 'Moisés foi escolhido por Deus para libertar o povo de Israel do Egito! Deus fez muitos milagres através dele, como abrir o Mar Vermelho para o povo passar. Moisés também recebeu os 10 Mandamentos de Deus!',
      lesson: 'Deus usa pessoas comuns para fazer coisas extraordinárias.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Moses%20with%20staff%2C%20parting%20red%20sea%2C%20colorful%20biblical%20scene%2C%20children%20illustration%20style%2C%20miraculous%20moment%20for%20kids%2C%20friendly%20character%20design&width=400&height=300&seq=moses-kids&orientation=landscape',
      funFact: 'Moisés viveu 120 anos e subiu numa montanha para falar com Deus!'
    },
    {
      id: 5,
      name: 'Jesus',
      story: 'Jesus é o Filho de Deus que veio à Terra para nos salvar! Ele nasceu como um bebezinho em Belém. Jesus fez muitos milagres: curou doentes, alimentou multidões e ressuscitou! Ele nos ama muito!',
      lesson: 'Jesus nos ama incondicionalmente e quer ser nosso melhor amigo.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Jesus%20with%20children%2C%20warm%20smile%2C%20colorful%20biblical%20scene%2C%20children%20illustration%20style%2C%20loving%20savior%20with%20kids%2C%20friendly%20and%20welcoming&width=400&height=300&seq=jesus-kids&orientation=landscape',
      funFact: 'Jesus transformou água em suco de uva (vinho) numa festa!'
    },
    {
      id: 6,
      name: 'José',
      story: 'José tinha uma túnica muito bonita e colorida! Seus irmãos ficaram com ciúmes e o venderam como escravo. Mas Deus tinha um plano especial! José se tornou governador do Egito e salvou muitas pessoas da fome!',
      lesson: 'Deus pode transformar coisas ruins em coisas boas.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Joseph%20with%20colorful%20coat%2C%20happy%20biblical%20character%2C%20children%20illustration%20style%2C%20bright%20colors%2C%20ancient%20Egypt%20setting%20for%20kids&width=400&height=300&seq=joseph-kids&orientation=landscape',
      funFact: 'José interpretava sonhos! Ele sabia o que os sonhos significavam!'
    },
    {
      id: 7,
      name: 'Ester',
      story: 'Ester era uma menina muito corajosa que se tornou rainha! Quando seu povo estava em perigo, ela foi falar com o rei para salvá-los. Mesmo com medo, ela confiou em Deus e salvou todos!',
      lesson: 'Deus nos dá coragem para ajudar outras pessoas.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Queen%20Esther%20in%20beautiful%20dress%2C%20brave%20princess%2C%20children%20illustration%20style%2C%20royal%20palace%2C%20colorful%20and%20inspiring%20for%20kids&width=400&height=300&seq=esther-kids&orientation=landscape',
      funFact: 'Ester jejuou (não comeu) por 3 dias para orar a Deus!'
    },
    {
      id: 8,
      name: 'Rute',
      story: 'Rute era uma menina muito bondosa! Quando sua sogra Noemi ficou triste e sozinha, Rute decidiu ficar com ela e cuidar dela. Deus abençoou Rute por sua bondade!',
      lesson: 'Devemos ser bondosos e cuidar das pessoas que amamos.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Ruth%20helping%20elderly%20Naomi%2C%20kind%20biblical%20character%2C%20children%20illustration%20style%2C%20caring%20and%20loving%20scene%2C%20bright%20colors%20for%20kids&width=400&height=300&seq=ruth-kids&orientation=landscape',
      funFact: 'Rute trabalhava no campo colhendo trigo para cuidar de Noemi!'
    },
    {
      id: 9,
      name: 'Samuel',
      story: 'Samuel era um menino que morava no templo com o sacerdote Eli. Uma noite, Deus chamou Samuel pelo nome! Samuel aprendeu a ouvir a voz de Deus e se tornou um grande profeta!',
      lesson: 'Deus fala conosco e devemos aprender a ouvir Sua voz.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20young%20Samuel%20in%20temple%2C%20boy%20prophet%20listening%20to%20God%2C%20children%20illustration%20style%2C%20peaceful%20temple%20scene%2C%20biblical%20character%20for%20kids&width=400&height=300&seq=samuel-kids&orientation=landscape',
      funFact: 'Samuel ungiu Davi para ser rei quando Davi ainda era um menino!'
    },
    {
      id: 10,
      name: 'Miriam',
      story: 'Miriam era a irmã de Moisés! Quando Moisés era bebê, ela o protegeu no rio. Depois, quando Deus salvou o povo do Egito, Miriam cantou e dançou de alegria com todas as mulheres!',
      lesson: 'Devemos proteger nossa família e celebrar as bênçãos de Deus.',
      image: 'https://readdy.ai/api/search-image?query=Cute%20cartoon%20Miriam%20dancing%20with%20tambourine%2C%20joyful%20biblical%20character%2C%20children%20illustration%20style%2C%20celebration%20scene%2C%20colorful%20and%20happy%20for%20kids&width=400&height=300&seq=miriam-kids&orientation=landscape',
      funFact: 'Miriam era profetisa e líder das mulheres de Israel!'
    }
  ];

  const quizQuestions = [
    {
      question: 'Quantos dias choveu no tempo de Noé?',
      options: ['30 dias', '40 dias', '50 dias', '60 dias'],
      correct: 1,
      character: 'Noé'
    },
    {
      question: 'Com que Davi venceu o gigante Golias?',
      options: ['Espada', 'Lança', 'Pedra e funda', 'Arco e flecha'],
      correct: 2,
      character: 'Davi'
    },
    {
      question: 'Onde Daniel foi jogado por orar a Deus?',
      options: ['Prisão', 'Cova dos leões', 'Poço', 'Deserto'],
      correct: 1,
      character: 'Daniel'
    },
    {
      question: 'Que mar Moisés abriu com a ajuda de Deus?',
      options: ['Mar Azul', 'Mar Verde', 'Mar Vermelho', 'Mar Amarelo'],
      correct: 2,
      character: 'Moisés'
    },
    {
      question: 'Onde Jesus nasceu?',
      options: ['Jerusalém', 'Nazaré', 'Belém', 'Cafarnaum'],
      correct: 2,
      character: 'Jesus'
    },
    {
      question: 'Que roupa especial José ganhou de seu pai?',
      options: ['Túnica colorida', 'Sandálias', 'Chapéu', 'Cinto'],
      correct: 0,
      character: 'José'
    },
    {
      question: 'Ester se tornou o quê?',
      options: ['Profetisa', 'Rainha', 'Sacerdotisa', 'Guerreira'],
      correct: 1,
      character: 'Ester'
    },
    {
      question: 'Quem Rute decidiu cuidar?',
      options: ['Sua mãe', 'Sua sogra Noemi', 'Sua irmã', 'Sua filha'],
      correct: 1,
      character: 'Rute'
    },
    {
      question: 'Onde Samuel morava quando era criança?',
      options: ['Casa dos pais', 'Palácio', 'Templo', 'Fazenda'],
      correct: 2,
      character: 'Samuel'
    },
    {
      question: 'Miriam era irmã de quem?',
      options: ['Davi', 'José', 'Moisés', 'Daniel'],
      correct: 2,
      character: 'Miriam'
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const handleQuizAnswer = (answerIndex: number) => {
    setSelectedAnswer(answerIndex);
    
    setTimeout(() => {
      if (answerIndex === quizQuestions[currentQuiz].correct) {
        setScore(score + 10);
      }
      
      if (currentQuiz < quizQuestions.length - 1) {
        setCurrentQuiz(currentQuiz + 1);
        setSelectedAnswer(null);
      } else {
        setShowQuizResult(true);
      }
    }, 1500);
  };

  const resetQuiz = () => {
    setCurrentQuiz(0);
    setScore(0);
    setShowQuizResult(false);
    setSelectedAnswer(null);
  };

  const selectedCharacterData = biblicalCharacters.find(char => char.id === selectedCharacter);

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-300 via-pink-300 to-purple-400">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-sm shadow-xl border-b-4 border-gradient-to-r from-yellow-400 to-pink-500">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200"
              />
              <div className="text-center flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm text-gray-600">Church Portugal</p>
              </div>
            </div>
            
            <nav className="flex items-center space-x-6">
              <button 
                onClick={() => navigate('/')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                <span>Início</span>
              </button>
              <button 
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-book-line"></i>
                <span>Bíblia</span>
              </button>
              <button 
                onClick={() => navigate('/characters')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-user-star-line"></i>
                <span>Personagens</span>
              </button>
              <button 
                onClick={() => navigate('/radio')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-yellow-600 hover:bg-yellow-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-radio-line"></i>
                <span>Rádio</span>
              </button>
              <button 
                onClick={() => navigate('/kids')}
                className="flex items-center space-x-2 px-4 py-2 text-yellow-600 bg-yellow-50 rounded-lg hover:bg-yellow-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-bear-smile-line"></i>
                <span>Crianças</span>
              </button>
              <button 
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-logout-box-line"></i>
                <span>Sair</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Banner */}
      <div className="relative h-64 bg-gradient-to-r from-yellow-400 via-pink-400 to-purple-500 overflow-hidden">
        <div className="absolute inset-0 bg-black/10"></div>
        <img 
          src="https://readdy.ai/api/search-image?query=Colorful%20children%20playing%20and%20learning%20about%20bible%2C%20happy%20kids%20with%20biblical%20characters%2C%20rainbow%20colors%2C%20fun%20educational%20atmosphere%2C%20cartoon%20style%20illustration&width=1200&height=300&seq=kids-banner&orientation=landscape"
          alt="Área Kids"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h2 className="text-4xl font-bold mb-2">🌟 Área Kids 🌟</h2>
            <p className="text-xl opacity-90">Aprenda sobre a Bíblia de forma divertida!</p>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-8">
        {!selectedCharacter ? (
          <>
            {/* Menu Principal */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              {/* Personagens Bíblicos */}
              <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-20 h-20 bg-gradient-to-r from-blue-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-user-star-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                    Personagens da Bíblia
                  </h3>
                  <p className="text-gray-600 mt-2">Conheça os heróis da fé!</p>
                </div>
                
                <div className="grid grid-cols-2 gap-4 max-h-80 overflow-y-auto">
                  {biblicalCharacters.map((character) => (
                    <button
                      key={character.id}
                      onClick={() => setSelectedCharacter(character.id)}
                      className="p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl hover:from-blue-100 hover:to-purple-100 transition-all duration-200 transform hover:scale-105 border-2 border-transparent hover:border-blue-300"
                    >
                      <div className="text-center">
                        <div className="text-2xl mb-2">
                          {character.name === 'Noé' && '🚢'}
                          {character.name === 'Davi' && '🎵'}
                          {character.name === 'Daniel' && '🦁'}
                          {character.name === 'Moisés' && '⚡'}
                          {character.name === 'Jesus' && '✨'}
                          {character.name === 'José' && '🌈'}
                          {character.name === 'Ester' && '👑'}
                          {character.name === 'Rute' && '💝'}
                          {character.name === 'Samuel' && '🙏'}
                          {character.name === 'Miriam' && '🎶'}
                        </div>
                        <h4 className="font-bold text-gray-800 text-sm">{character.name}</h4>
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              {/* Quiz Bíblico */}
              <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8 border border-white/20">
                <div className="text-center mb-6">
                  <div className="w-20 h-20 bg-gradient-to-r from-green-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                    <i className="ri-question-line text-3xl text-white"></i>
                  </div>
                  <h3 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent">
                    Quiz Bíblico
                  </h3>
                  <p className="text-gray-600 mt-2">Teste seus conhecimentos!</p>
                </div>

                {!showQuizResult ? (
                  <div className="space-y-6">
                    <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6">
                      <div className="flex items-center justify-between mb-4">
                        <span className="text-sm font-semibold text-green-700">
                          Pergunta {currentQuiz + 1} de {quizQuestions.length}
                        </span>
                        <span className="text-sm font-semibold text-blue-700">
                          Pontos: {score}
                        </span>
                      </div>
                      
                      <h4 className="text-lg font-bold text-gray-800 mb-4">
                        {quizQuestions[currentQuiz].question}
                      </h4>
                      
                      <div className="space-y-3">
                        {quizQuestions[currentQuiz].options.map((option, index) => (
                          <button
                            key={index}
                            onClick={() => handleQuizAnswer(index)}
                            disabled={selectedAnswer !== null}
                            className={`w-full p-3 rounded-xl text-left transition-all duration-200 ${
                              selectedAnswer === null
                                ? 'bg-white hover:bg-gradient-to-r hover:from-green-100 hover:to-blue-100 border-2 border-gray-200 hover:border-green-300'
                                : selectedAnswer === index
                                  ? index === quizQuestions[currentQuiz].correct
                                    ? 'bg-green-200 border-2 border-green-400'
                                    : 'bg-red-200 border-2 border-red-400'
                                  : index === quizQuestions[currentQuiz].correct
                                    ? 'bg-green-200 border-2 border-green-400'
                                    : 'bg-gray-100 border-2 border-gray-200'
                            }`}
                          >
                            {option}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="text-center space-y-6">
                    <div className="text-6xl">
                      {score >= 70 ? '🏆' : score >= 50 ? '🌟' : score >= 30 ? '👍' : '😊'}
                    </div>
                    <div>
                      <h4 className="text-2xl font-bold text-gray-800 mb-2">
                        Quiz Concluído!
                      </h4>
                      <p className="text-xl text-gray-600 mb-4">
                        Sua pontuação: <span className="font-bold text-green-600">{score} pontos</span>
                      </p>
                      <p className="text-gray-600">
                        {score >= 70 ? 'Excelente! Você conhece muito bem a Bíblia!' :
                         score >= 50 ? 'Muito bom! Continue estudando!' :
                         score >= 30 ? 'Bom trabalho! Que tal estudar mais?' :
                         'Continue tentando! A prática leva à perfeição!'}
                      </p>
                    </div>
                    <button
                      onClick={resetQuiz}
                      className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-8 py-3 rounded-xl font-semibold hover:from-green-600 hover:to-blue-600 transition-all duration-200 whitespace-nowrap"
                    >
                      Jogar Novamente
                    </button>
                  </div>
                )}
              </div>
            </div>

            {/* Atividades Extras */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-palette-line text-2xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Desenhos para Colorir</h4>
                <p className="text-gray-600 text-sm mb-4">Desenhos bíblicos para imprimir e colorir</p>
                <button className="bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-2 rounded-lg font-medium hover:from-yellow-600 hover:to-orange-600 transition-all duration-200 whitespace-nowrap">
                  Em Breve
                </button>
              </div>

              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-400 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-music-line text-2xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Músicas Infantis</h4>
                <p className="text-gray-600 text-sm mb-4">Louvores e canções bíblicas para crianças</p>
                <button className="bg-gradient-to-r from-pink-500 to-red-500 text-white px-6 py-2 rounded-lg font-medium hover:from-pink-600 hover:to-red-600 transition-all duration-200 whitespace-nowrap">
                  Em Breve
                </button>
              </div>

              <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center border border-white/20">
                <div className="w-16 h-16 bg-gradient-to-r from-indigo-400 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-gamepad-line text-2xl text-white"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-800 mb-2">Jogos Bíblicos</h4>
                <p className="text-gray-600 text-sm mb-4">Jogos educativos sobre a Bíblia</p>
                <button className="bg-gradient-to-r from-indigo-500 to-purple-500 text-white px-6 py-2 rounded-lg font-medium hover:from-indigo-600 hover:to-purple-600 transition-all duration-200 whitespace-nowrap">
                  Em Breve
                </button>
              </div>
            </div>
          </>
        ) : (
          /* Detalhes do Personagem */
          <div className="max-w-4xl mx-auto">
            <button
              onClick={() => setSelectedCharacter(null)}
              className="flex items-center space-x-2 text-blue-600 hover:text-blue-800 mb-6 whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i>
              <span>Voltar</span>
            </button>

            <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl overflow-hidden border border-white/20">
              <div className="relative h-64">
                <img 
                  src={selectedCharacterData?.image}
                  alt={selectedCharacterData?.name}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end">
                  <div className="p-8 text-white">
                    <h1 className="text-4xl font-bold mb-2">{selectedCharacterData?.name}</h1>
                    <div className="text-2xl">
                      {selectedCharacterData?.name === 'Noé' && '🚢 O Construtor da Arca'}
                      {selectedCharacterData?.name === 'Davi' && '🎵 O Pequeno Pastor'}
                      {selectedCharacterData?.name === 'Daniel' && '🦁 O Corajoso'}
                      {selectedCharacterData?.name === 'Moisés' && '⚡ O Libertador'}
                      {selectedCharacterData?.name === 'Jesus' && '✨ O Salvador'}
                      {selectedCharacterData?.name === 'José' && '🌈 O Sonhador'}
                      {selectedCharacterData?.name === 'Ester' && '👑 A Rainha Corajosa'}
                      {selectedCharacterData?.name === 'Rute' && '💝 A Nora Fiel'}
                      {selectedCharacterData?.name === 'Samuel' && '🙏 O Menino Profeta'}
                      {selectedCharacterData?.name === 'Miriam' && '🎶 A Irmã Protetora'}
                    </div>
                  </div>
                </div>
              </div>

              <div className="p-8 space-y-8">
                {/* História */}
                <div className="bg-gradient-to-r from-blue-50 to-purple-50 rounded-2xl p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-book-open-line text-blue-600 mr-3"></i>
                    A História de {selectedCharacterData?.name}
                  </h2>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {selectedCharacterData?.story}
                  </p>
                </div>

                {/* Lição */}
                <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-2xl p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-lightbulb-line text-green-600 mr-3"></i>
                    O que Aprendemos
                  </h2>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {selectedCharacterData?.lesson}
                  </p>
                </div>

                {/* Curiosidade */}
                <div className="bg-gradient-to-r from-yellow-50 to-orange-50 rounded-2xl p-6">
                  <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
                    <i className="ri-star-line text-yellow-600 mr-3"></i>
                    Curiosidade Divertida
                  </h2>
                  <p className="text-gray-700 text-lg leading-relaxed">
                    {selectedCharacterData?.funFact}
                  </p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
